import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  children,
  href,
  fullWidth = false,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-base font-semibold rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#10b981] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#10b981] text-white hover:bg-[#059669] shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-transparent border-2 border-[#10b981] text-[#10b981] hover:bg-[#10b981]/10'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`;
  if (href) {
    return <motion.a href={href} className={combinedClassName} whileTap={{
      scale: 0.98
    }} onClick={e => {
      // Only handle smooth scroll for internal anchors
      if (href.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
      // For external links, let the browser handle navigation normally
      // Call custom onClick if provided
      if (onClick) {
        onClick(e as any);
      }
    }} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} data-id="element-49">
        {children}
      </motion.a>;
  }
  return <motion.button className={combinedClassName} whileTap={{
    scale: 0.98
  }} onClick={onClick} {...props} data-id="element-50">
      {children}
    </motion.button>;
}